import * as React from 'react'

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Container from '@mui/material/Container'
import Button from '../components/Button'
import Typography from '../components/Typography'
import JoinInnerOutlinedIcon from '@mui/icons-material/JoinInnerOutlined'
import LocalLibraryOutlinedIcon from '@mui/icons-material/LocalLibraryOutlined'
import HubOutlinedIcon from '@mui/icons-material/HubOutlined'

const item = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    px: 5,
}

const number = {
    fontSize: 24,
    fontFamily: 'default',
    color: 'secondary.main',
    fontWeight: 'medium',
}

const image = {
    my: 4,
    fontSize: 'large'
}

function ProductHowItWorks() {
    return (
        <Box
            component="section"
            sx={{ display: 'flex', bgcolor: 'secondary.light', overflow: 'hidden' }}>
            <Container
                sx={{
                mt: 10,
                mb: 15,
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                }}>
                <Box
                    component="img"
                    src="/static/themes/onepirate/productCurvyLines.png"
                    alt="curvy lines"
                    sx={{
                        pointerEvents: 'none',
                        position: 'absolute',
                        top: -180,
                        opacity: 0.7,
                    }}/>
                <Typography variant="h4" marked="center" component="h2" sx={{ mb: 14 }}>How it works</Typography>
                <div>
                    <Grid container spacing={5}>
                        <Grid item xs={12} md={4}>
                            <Box sx={item}>
                                <Box sx={number}>1.</Box>
                                <JoinInnerOutlinedIcon fontSize='large' sx={{my: 4}}/>
                                <Typography variant="h5" align="center">Join Our Worship Services</Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Box sx={item}>
                                <Box sx={number}>2.</Box>
                                <LocalLibraryOutlinedIcon fontSize='large' sx={{my: 4}}/>
                                <Typography variant="h5" align="center">Get Involved in Our Community</Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Box sx={item}>
                                <Box sx={number}>3.</Box>
                                <HubOutlinedIcon fontSize='large' sx={{my: 4}}/>
                                <Typography variant="h5" align="center">Connect with Us</Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </div>
                <Button
                    color="secondary"
                    size="large"
                    variant="contained"
                    component="a"
                    href="/premium-themes/onepirate/sign-up/"
                    sx={{ mt: 8 }}>
                    Get started
                </Button>
            </Container>
        </Box>
    )
}

export default ProductHowItWorks
